import React from 'react';

const TermsPage = () => (
  <div className="max-w-2xl mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
    <p className="mb-4">Welcome to Strangeminder! By using this site, you agree to the following terms and conditions. Please read them carefully.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">1. Acceptance of Terms</h2>
    <p className="mb-4">By accessing or using Strangeminder, you agree to be bound by these Terms of Service and our Privacy Policy.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">2. User Conduct</h2>
    <p className="mb-4">You agree not to misuse the service or help anyone else do so. You are responsible for your use of the service and your content.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">3. Content</h2>
    <p className="mb-4">You retain ownership of your content, but you grant us a license to use, display, and distribute it as part of the service.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">4. Changes to Terms</h2>
    <p className="mb-4">We may update these terms from time to time. Continued use of the service means you accept the new terms.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">5. Contact</h2>
    <p>If you have any questions about these Terms, please contact us at support@strangeminder.com.</p>
  </div>
);

export default TermsPage; 